import { supabase } from '@/shared/lib/supabase';

/**
 * customerDataExportService — POPIA §23 self-service.
 *
 * Calls the deployed `popia-data-export` EF (returns a complete JSON
 * snapshot of every personal-data record we hold for the calling user).
 * Also lists past requests so the customer can see audit history.
 */

export type DataExportRequest = {
  id: string;
  requested_at: string;
  completed_at: string | null;
  status: string;
  expires_at: string | null;
};

export const customerDataExportService = {
  /** Fetch the full export bundle (returns JSON object). */
  async export(): Promise<unknown> {
    const { data, error } = await supabase.functions.invoke('popia-data-export', {
      method: 'POST',
    });
    if (error) {
      const body = (error as { context?: { body?: { message?: string } } }).context?.body;
      throw new Error(body?.message ?? (error as { message?: string }).message ?? 'Export failed.');
    }
    return data;
  },

  async listRequests(): Promise<DataExportRequest[]> {
    const { data, error } = await supabase
      .from('data_export_request')
      .select('id, requested_at, completed_at, status, expires_at')
      .order('requested_at', { ascending: false })
      .limit(50);
    if (error) throw new Error(`Could not load past requests: ${error.message}`);
    return (data ?? []) as DataExportRequest[];
  },
};
